/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface CioConditionEditorActionsArgs {
  canDuplicate?: boolean;
  canRemove?: boolean;
  onRemove?: () => unknown;
  onDuplicate?: () => unknown;
  showRefineButton: boolean;
  onRefine: () => unknown;
  disabled: boolean;
}

export default class CioConditionEditorActions extends Component<CioConditionEditorActionsArgs> {
  get canDuplicate() {
    return this.args.canDuplicate ?? false;
  }

  get canRemove() {
    return this.args.canRemove ?? true;
  }

  get showRefineButton() {
    return this.args.showRefineButton ?? false;
  }

  @action
  onDuplicate() {
    this.args.onDuplicate?.();
  }
}
